import { Injectable } from '@angular/core';
import { Firestore, collection, doc, query, where } from '@angular/fire/firestore';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import * as fromFoldActions from '../actions/folds.actions';

import { Observable, of } from 'rxjs';
import { map, catchError, switchMap, take } from 'rxjs/operators';
import { FirebaseService } from '../../services/firebase/firebase.service';
import { FoldFirebaseResponse } from '../../models/folds.model';

@Injectable()
export class FoldsEffects {

    constructor(
        private readonly action$: Actions,
        private readonly firestore: Firestore,
        private readonly firebaseService: FirebaseService,
    ) { }

    // Load Fold
    loadFold$: Observable<Action> = createEffect(() => this.action$.pipe(
        ofType(fromFoldActions.LoadFoldAction),
        switchMap(({ data }) => {
            const userRef = doc(this.firestore, `users/${data.id}`);
    
            const ref = query(
                collection(this.firestore, 'folds'),
                where('userRef', '==', userRef)
            );

            return this.firebaseService.getDataOfCollectionByField(ref).pipe(take(1), map((resp) => resp.map((doc) => ({
                ...doc as FoldFirebaseResponse
            }))));
        }),
        map((data) => {
            let folds: FoldFirebaseResponse = { registers: [] };
            if (data?.length > 0) {
                folds = data[0];
                folds.registers = folds.registers.map((register) => ({ ...register, date: new Date((register.date as unknown as { seconds: number }).seconds * 1000) }))
                delete folds.userRef;
            }
            return ({ type: fromFoldActions.LOAD_FOLD_SUCCESS, data: folds });
        }),
        catchError(error => of({ type: fromFoldActions.LOAD_FOLD_FAIL, error: error }))
    ));

    // Add Fold
    addFold$: Observable<Action> = createEffect(() => this.action$.pipe(
        ofType(fromFoldActions.AddFoldAction),
        switchMap(async ({ data, user }) => {
            const userRef = doc(this.firestore, `users/${user.id}`);
            const fold: FoldFirebaseResponse = {
                ...data,
                userRef
            };

            const resp = await this.firebaseService.addDoc('folds', fold);

            return { ...data, id: resp.id };
        }),
        map((data) => ({ type: fromFoldActions.ADD_FOLD_SUCCESS, data })),
        catchError(error => of({ type: fromFoldActions.ADD_FOLD_FAIL, error: error }))
    ));

    // Update Fold
    updateFold$: Observable<Action> = createEffect(() => this.action$.pipe(
        ofType(fromFoldActions.UpdateFoldAction),
        switchMap(async ({ data, user }) => {
            const userRef = doc(this.firestore, `users/${user.id}`);
            const fold: FoldFirebaseResponse = {
                ...data,
                userRef
            };
            delete fold.id;

            await this.firebaseService.updateDoc('folds', data.id!, fold);
            return data;
        }),
        map((data) => ({ type: fromFoldActions.UPDATE_FOLD_SUCCESS, data })),
        catchError(error => of({ type: fromFoldActions.UPDATE_FOLD_FAIL, error: error }))
    ));
}